import React, { useEffect, useState } from "react";
import { Menu } from "@headlessui/react";
import { FaBirthdayCake } from "react-icons/fa";
import { BiCalendar } from "react-icons/bi";
import { Link, useNavigate } from "react-router-dom";

function NotificationComp({ children, datas }) {
  const [notifications, setNotifications] = useState(datas);

  useEffect(() => {
    setNotifications(datas);
  }, [datas]);

  const markAllRead = () => {
    const updated = notifications.map((item) => ({
      ...item,
      read: true,
    }));
    setNotifications(updated);
  };

  const navigate = useNavigate();

  return (
    <Menu as="div" className="relative inline-block text-left w-full">
      <Menu.Button>{children}</Menu.Button>
      <Menu.Items className="flex flex-col w-[380px] sm:w-[420px] top-20 right-0 gap-4 absolute bg-drylight border border-subMain rounded-md shadow-lg py-4 px-6 ring-1 ring-border focus:outline-none z-50">
        <div className="flex justify-between items-center flex-wrap gap-4">
          <h2 className="text-md font-medium text-main text-text">
            Notifications
          </h2>
          <button
            onClick={markAllRead}
            className="px-4 py-2 hover:bg-text rounded-md text-subMain text-sm"
          >
            Mark all read
          </button>
        </div>

        <div className="flex flex-col gap-4 overflow-y-scroll max-h-[500px]">
          {notifications.length > 0 ? (
            notifications.map((item) => (
              <div
                key={item._id}
                onClick={() => {
                  setNotifications([]); // optional
                  navigate(`/appointments/${item._id}`);
                }}
                className={`w-full p-4 border border-border rounded-lg cursor-pointer ${
                  !item.read ? "bg-white/5" : "opacity-60"
                } hover:bg-white/10 transition duration-200`}
              >
                <div className="grid xs:grid-cols-12 gap-4 items-center">
                  <div className="xs:col-span-2">
                    <div
                      className={`${
                        item.action === 1
                          ? "bg-subMain text-yellowdark"
                          : "bg-dry text-subMain"
                      } w-12 h-12 rounded-full text-md flex-colo border-[.5px] border-subMain`}
                    >
                      {item.action === 1 ? <FaBirthdayCake /> : <BiCalendar />}
                    </div>
                  </div>
                  <div className="xs:col-span-10">
                    {item.action === 1 ? (
                      <p className="text-sm text-text">
                        It's{" "}
                        <span className="font-medium text-subMain">
                          {item.user.title}
                        </span>
                        's birthday today
                      </p>
                    ) : (
                      <p className="text-sm text-text">
                        Appointment with{" "}
                        <span className="text-main font-medium text-subMain">
                          {item.user.title}
                        </span>
                      </p>
                    )}
                    <div className="flex gap-4 text-xs text-textGray mt-2 font-light">
                      <p>{item.time}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-textGray text-center mt-4">
              No new notifications
            </p>
          )}
        </div>
      </Menu.Items>
    </Menu>
  );
}

export default NotificationComp;
